import React from 'react'
import {Group, Line, Rect, Text} from 'react-konva'
import {raise, useEvent} from '../events'
import {distance} from 'mathjs'
import {useSpring} from 'react-spring'
import {proportional} from '../proportional'
import {gameElement, intersect, lerp, mouseHandler} from '../utils'
import paper from './graphpaper.png'
import useImage from 'use-image'
import {Cubic} from '../easing'
import {getState} from '../game-surface'
import {playSound, registerSound} from '../sound'

const valid = registerSound('/valid shape.mp3')
const invalid = registerSound('/lift_arrive_beep.mp3')


const THRESHOLD = 12

const SKETCHPAD = {
    x: 2048 - 820 + 380,
    y: 500,
    scaleX: 1,
    scaleY: 1,
    width: 760,
    height: 800,
}
const current = {}

function SketchPad({ data }) {
    const state = data('pad', {
        points: [],
        isShape: false,
        drawing: false,
        error: 0,
    })

    const [props, set] = useSpring(() => ({
        backgroundColor: 'beige',
        scale: 1,
        config: {mass: 7, tension: 350, friction: 40},
    }))
    const [image] = useImage(paper)
    Object.assign(current, SKETCHPAD)
    current.x =
        current.x + lerp(1000, 0, Cubic.Out(lerp(0, 1, (getState().height - 50) / 40)))
    current.scaleX *= props.scale.value
    current.scaleY *= props.scale.value
    return (
        <Group
            {...mouseHandler('drawing', {x: 0, y: 0})}
            {...proportional(current)}
        >
            <Group x={-380} y={-400}>
                <Rect
                    shadowBlur={12}
                    shadowColor={'rgba(0,0,0,0.4)'}
                    shadowOffsetX={10}
                    shadowOffsetY={10}
                    width={760}
                    height={800}
                    fill={props.backgroundColor.getValue()}
                    cornerRadius={20}
                />
                {image && (
                    <Rect
                        y={20}
                        width={750}
                        height={760}
                        opacity={0.4}
                        fillPatternImage={image}
                        fillPatternScaleX={0.92}
                        fillPatternScaleY={0.92}
                        cornerRadius={20}
                    />
                )}

                <Text x={20} y={20} fontSize={25} fill="#444" text="ROCKET-REPAIR SKETCH PAD x1.5 MAG."/>
                <Text x={20} y={50} fontSize={15} fill="#999" text="DRAW YOUR REPAIRS FOR INSTANT MANUFACTURE"/>
                {state.isShape &&
                <Text x={20} y={770} fontSize={22} fill="#AAA" text="DRAG MANUFACTURED PART TO ROCKET"/>}
                <Drawing set={set} state={state}/>
            </Group>
        </Group>
    )
}
SketchPad.z = 1000
gameElement(SketchPad)

let x = 0

function Drawing({ set, state }) {
    const {points, isShape, drawing} = state
    if (--state.error > 0) {
        set({backgroundColor: 'salmon', scale: 0.9})
    } else {
        set(
            isShape
                ? {scale: 1.07, backgroundColor: '#CFDBC5'}
                : {scale: 1, backgroundColor: 'beige'}
        )
    }

    useEvent('dragging', () => {
        state.isShape = false
        state.points = []
    })

    // useGameElement(Hello, isShape)
    useEvent('drawing.mouseDown', (newPosition) => {
        state.points = newPosition
        raise('shape-cleared')
        state.drawing = true
        state.isShape = false
    })
    useEvent('drawing.mouseMove', (newPosition) => {
        if (!drawing) return
        let newPoints = closed(points, newPosition)
        if (newPoints) {
            state.points = newPoints
            state.drawing = false
            state.isShape = true
            playSound(valid)
            return
        }
        try {
            if (distance(points.slice(-2), newPosition) > THRESHOLD) {
                let newPoints = [...points, ...newPosition]
                state.points = newPoints
            }
        } catch (e) {}
    })
    useEvent('drawing.mouseUp', () => {
        state.drawing = false
        if (!isShape) {
            if (points.length > 2) {
                state.error = 20
                playSound(invalid)
            }
            let current = state.points
            setTimeout(
                () => state.points === current && (state.points = []),
                300
            )
        } else {
            console.log('Drawn')
            raise('shape-drawn', points)
        }
    })
    return points.length <= 2 ? null : (
        <Line
            x={0}
            y={0}
            lineCap="round"
            points={points}
            closed={isShape}
            fill={'rgba(0,0,0,0.2)'}
            tension={0.2}
            stroke="#666"
            strokeWidth={8}
        />
    )
}

function closed(points, position) {
    const lastLine = [...points.slice(-2), ...position]
    let first = [points[0], points[1]]
    for (let i = 2; i < points.length - 6; i += 2) {
        const next = points.slice(i, i + 2)
        const intersection = intersect(...first, ...next, ...lastLine)
        first = next
        if (intersection) {
            return [...intersection, ...points.slice(i + 2), ...intersection]
        }
    }
}
